import useCreateDetail, {
  UseCreateDetailOptions,
} from '@/service-library/core-hooks/useCreateDetail'
import { createDetail } from '@/service-library/request-wrappers'
import {
  CreateEntrataClientRequest,
  CreateEntrataClientResponse,
} from '@/types/entrata-client'

/**
 * MARK: Custom Hook: Create Entrata Client
 * Provisions a new Entrata client and its property organizations.
 */
export default function useCreateEntrataClient(
  options: UseCreateDetailOptions<
    CreateEntrataClientRequest,
    CreateEntrataClientResponse
  > = {},
) {
  const mutation = useCreateDetail<
    CreateEntrataClientRequest,
    CreateEntrataClientResponse
  >({
    serviceFn: ({ filters, item, axiosOptions }) => {
      return createDetail<
        CreateEntrataClientRequest,
        CreateEntrataClientResponse
      >({
        url: '/v2/relay-entrata/clients/create_client',
        item,
        filters,
        axiosOptions,
      })
    },
    ...options,
  })

  return {
    createEntrataClient: mutation.mutate,
    createEntrataClientAsync: mutation.mutateAsync,
    ...mutation,
  }
}
